import { Text } from "@merge-api/merge-javascript-shared";
import { CloudMoon } from "lucide-react";
import GradientIcon from "../../../../shared/icons/GradientIcon";
import { AutomatedTestSuiteExecution } from "../types";
import IndividualTestExecutionCard from "./IndividualTestExecutionCard";

interface AutomatedTestResultsContainerProps {
  automatedTestSuiteExecution: AutomatedTestSuiteExecution | null;
}

const AutomatedTestResultsContainer = ({
  automatedTestSuiteExecution,
}: AutomatedTestResultsContainerProps) => {
  // If no execution data, show empty state
  if (!automatedTestSuiteExecution || Object.keys(automatedTestSuiteExecution.tests).length === 0) {
    return (
      <div className="flex flex-col items-center justify-center px-6 py-8 space-y-4">
        <GradientIcon Icon={CloudMoon} size={32} endColor="#2DB9EE" startColor="#0042E5" />
        <Text variant="h5" className="text-gray-40">
          No automated test suite results
        </Text>
      </div>
    );
  }

  // Render individual test cards
  const testEntries = Object.entries(automatedTestSuiteExecution.tests);

  return (
    <div className="space-y-3">
      {testEntries.map(([testName, testExecution]) => (
        <IndividualTestExecutionCard
          key={testName}
          testName={testName}
          testExecution={testExecution}
        />
      ))}
    </div>
  );
};

export default AutomatedTestResultsContainer;
